import { createLogic } from 'redux-logic'
import { CHANNEL_MEZZO_DEVICES } from '../constants/channels'
import { UNSUBSCRIBE } from '../constants/mezzoDevices'


const unsubscribeMezzoDevices = createLogic({
  type: UNSUBSCRIBE,

  process(_, dispatch, done) {
    if (global.localCable) {
      global.localCable.subscriptions.subscriptions.forEach(
        sub => sub.identifier.includes(CHANNEL_MEZZO_DEVICES) && sub.unsubscribe(),
      )
    }
    if (global.cloudCable) {
      global.cloudCable.subscriptions.subscriptions.forEach(
        sub => sub.identifier.includes(CHANNEL_MEZZO_DEVICES) && sub.unsubscribe(),
      )
    }
    done()
  },
})

export default unsubscribeMezzoDevices
